import React, { useState, useEffect } from "react";
import { Modal, Select, DatePicker, Radio, InputNumber, TreeSelect } from "antd";
import moment from "moment";
const { TreeNode } = TreeSelect;
const { Option } = Select;

export const TransactionModal = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
  categories,
  banks,
}) => {
  const tags = [
    "Me",
    "For Family",
    "For Child",
    "For Friends",
    "For Consultant",
  ];
  // const categories = [
  //   "Shopping",
  //   "Groceries",
  //   "Fast Food",
  //   "Traveling",
  //   "Fruit",
  // ];
  console.log("data in modal", data);
  return (
    <div>
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">{title}</h3>
          {title === "Edit Transaction" && data && data.bankName && (
            <div className="accountNumber"> {data.bankName}</div>
          )}
          {title === "Edit Transaction" && data && data.accountNumber && (
            <div className="accountNumber">{"****" + data.accountNumber}</div>
          )}
        </div>
        <div
          style={{
            marginTop: "1rem",
            maxHeight: "25rem",
            overflow: "scroll",
            padding: "1rem",
          }}
        > 
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Date <span style={{ color: "red" }}>*</span>
            </h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Date"
              name="date"
              value={data && data.date && moment.utc(data.date)}
              id="newDate"
              onChange={(date, dateString) => {
                handleChange("date", dateString);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Item Name <span style={{ color: "red" }}>*</span>
            </h3>
            <input
              className="roleInput"
              placeholder="Item Name"
              name="itemName"
              value={data && data.itemName}
              id="itemName"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Description</h3>
            <input
              className="roleInput"
              placeholder="Description"
              name="description"
              value={data && data.description}
              id="amount"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Bank Account</h3>
            <Select
              showSearch
              placeholder="-Select-"
              value={data && data.accountTitle}
              onChange={(value, id) => {
                handleChange("accountTitle", value);
              }}
            >
              {banks &&
                banks.map((item, index) => (
                  <Option key={index} value={item.accountTitle}>
                    {item.accountTitle}
                  </Option>
                ))}
            </Select>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Category</h3>
            <TreeSelect
              showSearch
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder="Choose Category"
              allowClear
              // treeDefaultExpandAll
              value={data && data.categoryName}
            onChange={(value, label,extra) => {
                const selectedNode = extra.triggerNode;
                const parentNode = selectedNode && selectedNode.props.label;
              const selectedCategory = parentNode ? `${value}-${parentNode}` : value;
              console.log("selectedCategory",selectedCategory);
                handleChange("category", selectedCategory);
            }}
          >
            {categories && categories.map(category => {
                  let parentLabel = category.categoryName;
                  return (
                <TreeNode key={category.id} value={category.categoryName} title={category.categoryName} >
                      {category.subCategories.map((subCategory, index) => (
                    <TreeNode key={`${category.id}-${index}`} value={subCategory.name} title={subCategory.name} label={parentLabel} />
                      ))}
                    </TreeNode>
                  );
                })}
            </TreeSelect>
          

            {/*<Select
              showSearch
              placeholder="-Select-"
              value={data && data.categoryName}
              onChange={(value, id) => {
                console.log("value", value);
                handleChange("categoryName", value);
              }}
            >
              {categories &&
                categories.map((item, index) => (
                  <Option key={index} value={item.categoryName}>
                    {item.categoryName}
                  </Option>
                ))}
              </Select> */}
          </div>
          <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">Expense or Income <span style={{ color: "red" }}>*</span></h3>
            <Radio.Group
              buttonStyle="solid"
              name="typeOfTransaction"
              value={data && data.typeOfTransaction}
              onChange={(e) => {
                handleChange(e.target.name, e.target.value);
            }}
          >
              {["Expense", "Income"].map((value, vindex) => (
                <Radio.Button key={vindex} value={value}>
                  {value}
                </Radio.Button>
              ))}
            </Radio.Group>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              {data &&
                (data.typeOfTransaction === "Expense"
                  ? "Expense"
                  : data.typeOfTransaction === "Income"
                  ? "Income"
                : null)} Amount <span style={{ color: "red" }}>*</span>
            </h3>
            <div className="inputWrapper" style={{display:"flex"}}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border:"1px solid #d1d5db"
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Amount"
                name="amount"
                value={data && data.amount}
                id="amount"
                onChange={(value) => {
                  handleChange("amount", value);
                }}
              />
            </div>
          </div>
          {/* <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">Tags</h3>
          <Select
            showSearch
            placeholder="-Select-"
            value={data && data.tags}
            onChange={(value, id) => {
              console.log("value", value);
              handleChange("tags", value);
            }}
          >
            {tags &&
              tags.map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
          </Select>
              </div> */}
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Cash or Check</h3>
            <Radio.Group
              buttonStyle="solid"
              name="paidUsing"
              value={data && data.paidUsing}
              onChange={(e) => {
                handleChange(e.target.name, e.target.value);
              }}
            >
              {["Cash", "Check"].map((value, vindex) => (
                <Radio.Button
                  key={vindex}
                  value={value}
                  onClick={() => {
                    console.log(value);
                    handleChange("paidUsing", value);
                  }}
                >
                    {value}
                </Radio.Button>
              ))}
            </Radio.Group>
          </div>

          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Notes</h3>
            <input
              className="roleInput"
              placeholder="Notes"
              name="notes"
              value={data && data.notes}
              id="note"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.date || !data.itemName || !data.amount || !data.typeOfTransaction}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
